export default __webpack_public_path__ + "static/media/remove.0707f9d2.svg";